import { message } from 'antd';

type ErrorResponse = {
  displayMessage: string;
  debugInfo: string;
  timestamp: number;
};

const asyncErrorHandler = (
  errObj: ErrorResponse,
  errorMsg?: string,
  errorPrefix?: string
) => {
  if (errorMsg) {
    message.error(errorMsg);
  }
  if (errorPrefix) {
    console.error(errorPrefix, errObj.debugInfo ?? errObj);
  }
};

export { asyncErrorHandler, ErrorResponse };
